document.addEventListener('DOMContentLoaded', function() {
  // Mapping of ACF section values to their actual page selectors
  const sectionSelectors = {
    'introduction': '.procedure-intro-child',
    'what_is': '.procedure-what',
    'types': '.content-switcher',
    'benefits': '#types',
    'candidates': '#types',
    'first_step': '#steps',
    'expect': '#expect',
    'recovery': '#recovery',
    'cost': '#cost',
    'why_choose': '#why',
    'faqs': '.faq-section'
  };

  // Get all TOC links
  const tocLinks = document.querySelectorAll('.toc-links a');

  tocLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // Get the href value (e.g., "#introduction")
      const href = this.getAttribute('href');
      const sectionKey = href.replace('#', '');

      // Get the actual selector for this section
      const targetSelector = sectionSelectors[sectionKey];

      if (!targetSelector) {
        console.warn(`No selector found for section: ${sectionKey}`);
        return;
      }

      // Find the target element
      const targetElement = document.querySelector(targetSelector);

      if (targetElement) {
        // Calculate offset (adjust this value based on your header height)
        const headerOffset = 100; // Change this value to match your fixed header height
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        // Smooth scroll to the target
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } else {
        console.warn(`Target element not found: ${targetSelector}`);
      }
    });
  });
});
